import addDays from 'date-fns/addDays';
import addHours from 'date-fns/addHours';
import addMinutes from 'date-fns/addMinutes';
import isPast from 'date-fns/isPast';
import parse from 'date-fns/parse';

export function getEndDateTime(date: Date, duration) {
  return addDays(
    addHours(addMinutes(date, duration.minutes), duration.hours),
    duration.days,
  );
}

export function isExpired(booking) {
  const parsedTripDate = parse(
    booking.trip_date,
    "yyyy-MM-dd'T'HH:mm",
    new Date(),
  );
  return isPast(getEndDateTime(parsedTripDate, booking.tripDuration));
}
